// extracted by mini-css-extract-plugin
module.exports = {"timer":"styles_timer__bul_F","value":"styles_value__DKXci"};